import { BaseDataChannel } from "./BaseDataChannel";
import { generatePngMap } from "../../utils/spatial";
import { RobotSlamMap } from "../../models/Deployment";

export class MapChannel extends BaseDataChannel {
  public lastReceivedMap: RobotSlamMap | null = null;
  public onMessage(ev: MessageEvent): void {
    const data = ev.data;
    // split the data into two buffers, 8 bytes for the first and rest for the second
    const buffer = new Uint8Array(data);
    const originBufferLength = 3 * 4;
    const originBuffer = buffer.slice(0, originBufferLength);
    const mapBuffer = buffer.slice(originBufferLength);
    const originView = new Float32Array(originBuffer.buffer);
    // const mapView = new Uint8Array(mapBuffer.buffer);
    const map: RobotSlamMap = {
      robotId: this.stateManager!.getActorId(),
      offsetX: originView[0],
      offsetY: originView[1],
      resolution: originView[2],
      storageBlobId: '',
      data: mapBuffer.buffer,
    };
    this.lastReceivedMap = map;
    this.emit('map', map);
    // this.renderMap();
  }

  // protected renderMap() {
  //   this.stateManager!.getUIService().getMapFloorFactory().renderSlamMap(this.lastReceivedMap!);
  // }

  public getConfiguration() {
    return {
      name: "map",
    };
  }

  public async generateMapFromSim(): Promise<void> {
    if (!this.stateManager) {
      return;
    }
    const uiService = this.stateManager.getUIService();
    const map = uiService.map;
    const size = map.settings.floorSize || 200;
    // const buffer = await generatePngMap(uiService, 50, true, 0.05);
    const buffer = await generatePngMap(uiService, size, 0.2);
    console.log('Generated map buffer with size: ', buffer.byteLength);
    this.sendBytes(buffer);
  }


}
